import { Canvg, RenderingContext2D } from "canvg";

export default async function parseSvg(id: string): Promise<string> {
  const serializer = new XMLSerializer();
  const SVGDomElement = document.getElementById(id);
  let data = "";
  if (SVGDomElement) {
    SVGDomElement.style.display = "initial";
    const serializedSVG = serializer.serializeToString(SVGDomElement);
    const base64Data = window.btoa(serializedSVG);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    SVGDomElement.style.display = "none";
    data = `data:image/svg+xml;base64,${base64Data}`;

    try {
      const v = await Canvg.from(ctx as RenderingContext2D, data);
      v.start();
      data = canvas.toDataURL("image/png", 100);
      v.stop();
    } catch (err) {
      console.log("ERRO => ", err);
    }
  }
  return data;
}
